<!--  -->

<template>
  <div class="firm-body">
    <!-- 面包屑  -->

    <p class="title-Individual-center">
      <span>招聘管理</span>

      <i class="el-icon-arrow-right"></i>

      <span class="span-Individual-center">{{ routeName }}</span>
    </p>

    <!-- 主要内容 -->

    <div class="box">
      <!-- 日报 周报 月报切换按钮 -->

      <div class="box-nav">
        <div @click="textChange(index)" :class="index == isIndex ? 'nav-text active' : 'nav-text'"
          v-for="(item, index) in textList" :key="index">
          {{ item }}
        </div>
      </div>

      <div class="flex-box" style="margin-top: 30px">
        <!-- 日期选择组件 -->

        <dateWeek @getItem="getItem" @getItem2="getItem2" @getItem3="getItem3" :timeIndex="isIndex"></dateWeek>

        <!-- 职位选择 -->

        <div class="flex-box2" style="margin-left: 60px">
          <span style="font-size: 14px; width: 80px">职位选择：</span>

          <el-select v-model="value" placeholder="请选择职位" style="width: 220px" @change="handlePositionChange">
            <el-option label="全部" value=""> </el-option>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <!-- 统计信息 -->

      <div class="change-box">
        <div v-for="(item, index) in arrList" :key="index"
          :class="isIndex2.includes(index) ? 'change-item active2' : 'change-item'" @click="active2Change(index)">
          <div style="font-size: 14px; color: #333333">
            {{ item.name }}
          </div>

          <div style="color: #333; margin-top: 12px; font-size: 12px">
            <span v-if="isIndex == 0">（{{ item.text }}）</span>

            <span v-if="isIndex == 1">（{{ item.text1 }}）</span>

            <span v-if="isIndex == 2">（{{ item.text2 }}）</span>
          </div>

          <div style="float: right">
            <div style="
                font-size: 14px;

                color: #fe574a;

                text-align: right;

                margin: 12px 0 10px;
              ">
              {{ item.count || 0 }}
            </div>

            <div style="font-size: 12px; color: #999">
              较昨日+{{ item.change || 0 }}
            </div>
          </div>
        </div>

        <div class="change-item" style="height: 0; padding: 0"></div>

        <div class="change-item" style="height: 0; padding: 0"></div>
      </div>

      <!-- 日报趋势图 -->

      <div v-show="isIndex == 0">
        <div class="flex-box">
          <div class="flex-box2">
            <span style="font-size: 16px">趋势图</span>

            <span style="font-size: 16px; color: #999">（{{ isIndex2.length > 0 ? arrList[isIndex2[0]].name : '请选择统计类型'
            }}{{ isIndex2.length > 1 ? ` 等${isIndex2.length}项` : '' }}）</span>
          </div>

          <!-- 近 1 4 12周 -->

          <div class="recently-box">
            <div class="firm-clickable" v-for="(item, index) in recentlyList" :key="index"
              @click="recentlyChange(index)" :class="index == recentlyIndex
                ? 'recently-item active'
                : 'recently-item'
                ">
              {{ item.name }}
            </div>
          </div>
        </div>

        <!-- 趋势图 -->

        <div id="main" style="width: 100%; height: 400px"></div>
      </div>

      <!-- 周报 月报表格 -->

      <div v-show="isIndex == 1 || isIndex == 2">
        <div class="flex-box" style="margin: 30px 0">
          <div style="font-size: 16px">数据统计</div>
        </div>

        <el-table :data="tableDataList.length > 0 ? tableDataList : tableData" style="width: 100%"
          :row-class-name="tableRowClassName" :cell-style="{ 'text-align': 'center', 'font-size': '12px' }"
          :header-cell-style="{
            background: '#409eff ',

            color: '#fff',

            'text-align': 'center',

            'font-size': '12px',

            'font-weight': '300',
          }">
          <el-table-column prop="createTimeString" label="日期" width="180">
          </el-table-column>

          <el-table-column prop="meSeen" label="我看过" width="180">
          </el-table-column>

          <el-table-column prop="seenMe" label="看过我"> </el-table-column>

          <el-table-column prop="communicated" label="沟通过">
          </el-table-column>

          <el-table-column prop="workplaceCredit" label="职场信用">
          </el-table-column>

          <el-table-column prop="exchangeContact" label="交换联系方式">
          </el-table-column>

          <el-table-column prop="collect" label="收藏"> </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div style="margin-top: 20px; float: right;">
          <paging :pagingObj="pagingObj" @handleCurrentChange="handleCurrentChange"></paging>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import dateWeek from "./components/dateWeek.vue";

const echarts = require("echarts");

// 引入分页组件

import paging from "../../../../components/paging.vue";

import {
  getRecruitmentData,
  listRecruitment,
  getPublishPositionInfoList,
  getRecruitmentTrendChart
} from "@/assets/api/firm/firmRecruit.js";

export default {
  components: { dateWeek, paging },

  data() {
    return {
      // 图表实例
      myChart: null,
      // 路由名称

      routeName: "",

      textList: ["日报", "周报", "月报"],

      // 日报 周报 月报 切换索引

      isIndex: 0,

      // 统计信息切换索引（支持多选）

      isIndex2: [0],

      // 职位列表

      options: [],

      // 职位选择值

      value: "",

      // API参数

      positionId: null, // 职位id

      tabType: 0, // 0:日报, 1:周报, 2:月报

      startTime: "", // 开始时间

      endTime: "", // 结束时间

      // API返回的数据

      recruitmentData: null, // 招聘数据概览

      trendData: [], // 趋势图数据

      tableDataList: [], // 表格数据

      // 分页相关

      pagingObj: {
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示条数
        totalDevice: 0, // 总条数
      },

      // 统计信息数据

      arrList: [
        {
          name: "我看过",

          text: "统计今日我看过的在线简历",

          text1: "统计一周我看过的在线简历",

          text2: "统计此月我看过的在线简历",
        },

        {
          name: "看过我",

          text: "统计今日看过我招聘信息的人",

          text1: "统计一周看过我招聘信息的人",

          text2: "统计此月看过我招聘信息的人",
        },

        {
          name: "沟通过",

          text: "统计今日所有沟通过的精英",

          text1: "统计一周所有沟通过的精英",

          text2: "统计此月所有沟通过的精英",
        },

        {
          name: "职场信用",

          text: "统计今日查看过的职场信用精英",

          text1: "统计一周查看过的职场信用精英",

          text2: "统计此月查看过的职场信用精英",
        },

        {
          name: "交换联系方式",

          text: "统计今日交换过联系方式",

          text1: "统计一周交换过联系方式",

          text2: "统计此月交换过联系方式",
        },

        {
          name: "收藏",

          text: "统计今日收藏过的精英",

          text1: "统计一周收藏过的精英",

          text2: "统计此月收藏过的精英",
        },
      ],

      // 1 4 12 周名称

      recentlyList: [
        {
          name: "近1周",

          id: 1,
        },

        {
          name: "近4周",

          id: 2,
        },

        {
          name: "近12周",

          id: 3,
        },
      ],

      // 切换索引

      recentlyIndex: 0,

      // 表格数据

      tableData: [
      ],
    };
  },

  created() {
    // 获取当前路由名称

    this.routeName = this.$route.name;

    // 初始化日期范围

    this.initDateRange();

    // 获取职位列表

    this.getPositionList();

    // 获取招聘数据

    this.getRecruitmentData();
  },

  mounted() {
    this.drawChart();
  },

  beforeDestroy() {
    // 组件销毁时销毁图表实例
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  },

  methods: {
    // 获取职位列表

    async getPositionList() {
      const res = await getPublishPositionInfoList({ data: {} });

      if (res.code === 0) {
        this.options = res.data.map((item) => ({
          value: item.positionId,

          label: item.positionName,
        }));
      }
    },

    // 初始化日期范围

    initDateRange() {
      const today = new Date();

      const year = today.getFullYear();

      const month = String(today.getMonth() + 1).padStart(2, "0");

      const day = String(today.getDate()).padStart(2, "0");

      // 根据tabType设置不同的日期范围

      if (this.tabType === 0) {
        // 日报：今日

        this.startTime = `${year}-${month}-${day} 00:00:00`;

        this.endTime = `${year}-${month}-${day} 23:59:59`;
      } else if (this.tabType === 1) {
        // 周报：本周一到本周日

        const dayOfWeek = today.getDay();

        const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // 周日为0，需要特殊处理

        const monday = new Date(today);

        monday.setDate(today.getDate() - diff);

        const sunday = new Date(today);

        sunday.setDate(today.getDate() + (6 - diff));

        const startYear = monday.getFullYear();

        const startMonth = String(monday.getMonth() + 1).padStart(2, "0");

        const startDay = String(monday.getDate()).padStart(2, "0");

        const endYear = sunday.getFullYear();

        const endMonth = String(sunday.getMonth() + 1).padStart(2, "0");

        const endDay = String(sunday.getDate()).padStart(2, "0");

        this.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`;

        this.endTime = `${endYear}-${endMonth}-${endDay} 23:59:59`;
      } else if (this.tabType === 2) {
        // 月报：本月1日到本月最后一天

        const firstDay = new Date(year, today.getMonth(), 1);

        const lastDay = new Date(year, today.getMonth() + 1, 0);

        const startYear = firstDay.getFullYear();

        const startMonth = String(firstDay.getMonth() + 1).padStart(2, "0");

        const startDay = String(firstDay.getDate()).padStart(2, "0");

        const endYear = lastDay.getFullYear();

        const endMonth = String(lastDay.getMonth() + 1).padStart(2, "0");

        const endDay = String(lastDay.getDate()).padStart(2, "0");

        this.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`;

        this.endTime = `${endYear}-${endMonth}-${endDay} 23:59:59`;
      }
    },

    // 获取招聘数据

    async getRecruitmentData() {
      const data = {
        data: {
          positionId: this.positionId,

          tabType: this.tabType,

          startTime: this.startTime,

          endTime: this.endTime,
        },
      };

      const res = await getRecruitmentData(data);

      if (res.code === 0) {
        this.recruitmentData = res.data;

        // 更新统计卡片数据

        this.updateStatisticsCards();

        // 如果是日报，更新趋势图

        if (this.tabType === 0) {
          this.isIndex2 = [0]
          this.updateTrendChart();
        } else {
          // 如果是周报或月报，更新表格数据
          this.updateTableData();
        }
      }
    },

    // 更新统计卡片数据

    updateStatisticsCards() {
      if (!this.recruitmentData) return;

      // 根据API返回的数据更新统计卡片

      const data = this.recruitmentData;

      // 映射API字段到统计卡片

      const fieldMapping = {
        我看过: { count: "meSeen", change: "meSeenContrastCount" },

        看过我: { count: "seenMe", change: "seenMeContrastCount" },

        沟通过: { count: "communicated", change: "communicatedContrastCount" },

        职场信用: {
          count: "workplaceCredit",
          change: "workplaceCreditContrastCount",
        },

        交换联系方式: {
          count: "exchangeContact",
          change: "exchangeContactContrastCount",
        },
        收藏: { count: "collect", change: "collectContrastCount" },
      };
      this.arrList.forEach((item, index) => {
        const mapping = fieldMapping[item.name];

        if (mapping) {
          item.count = data[mapping.count] || 0;

          item.change = data[mapping.change] || 0;
        }
      });
      this.$forceUpdate()
    },

    // 更新趋势图数据

    async updateTrendChart() {
      const data = {
        data: {
          positionId: this.positionId,
          periodOption: this.recentlyIndex,
          startTime: this.startTime,
          typeList: this.isIndex2
        },
      };
      const res = await getRecruitmentTrendChart(data);
      if (res.code === 0) {
        // 处理返回的数据结构：对象键是类型编号，值是对应的数据数组
        const trendDataObj = res.data || {};
        // 提取所有日期（从第一个类型的数据中获取）
        const firstTypeKey = Object.keys(trendDataObj)[0];
        const dates = firstTypeKey ? trendDataObj[firstTypeKey].map(item => item.time) : [];

        // 将数据转换为ECharts需要的格式
        this.trendData = trendDataObj;
        this.recruitmentData = {
          ...this.recruitmentData,
          dates: dates
        };
        // 使用$nextTick确保DOM更新后再绘制图表
        this.$nextTick(() => {
          this.drawChart();
        });
      }
    },

    // 更新表格数据

    async updateTableData() {
      const data = {
        data: {
          positionId: this.positionId,

          tabType: this.tabType,

          startTime: this.startTime,

          endTime: this.endTime,
        },
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
      };

      const res = await listRecruitment(data);

      if (res.code === 0) {
        this.tableDataList = res.data.list || res.data || [];
        this.pagingObj.totalDevice = res.data.total || res.data.length || 0;
      }
    },

    // 日报 周报 月报切换方法

    textChange(index) {
      this.isIndex = index;
      this.tabType = index; // 更新API参数
      if (this.isIndex == 1 || this.isIndex == 2) {
        this.isIndex2 = ''
      }
      // 切换时重新初始化日期范围

      this.initDateRange();

      // 重置分页
      this.pagingObj.currentPage = 1;

      // 使用$nextTick确保dateWeek组件更新后再获取数据

      this.$nextTick(() => {
        this.getRecruitmentData();
      });
    },

    // 日报切换返回

    getItem(item) {

      this.startTime = item.date + " 00:00:00";

      this.endTime = item.date + " 23:59:59";

      this.getRecruitmentData(); // 重新获取数据
    },

    // 周报 切换返回

    getItem2(item) {
      this.startTime = item.start + " 00:00:00";

      this.endTime = item.end + " 23:59:59";

      this.getRecruitmentData(); // 重新获取数据
    },

    // 月报切换返回

    getItem3(item) {
      console.log(item, 3);

      const year = item.year;

      const month = item.month;

      // 计算该月的第一天和最后一天

      const firstDay = new Date(year, month - 1, 1);

      const lastDay = new Date(year, month, 0);

      const startYear = firstDay.getFullYear();

      const startMonth = String(firstDay.getMonth() + 1).padStart(2, "0");

      const startDay = String(firstDay.getDate()).padStart(2, "0");

      const endYear = lastDay.getFullYear();

      const endMonth = String(lastDay.getMonth() + 1).padStart(2, "0");

      const endDay = String(lastDay.getDate()).padStart(2, "0");

      this.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`;

      this.endTime = `${endYear}-${endMonth}-${endDay} 23:59:59`;

      this.getRecruitmentData(); // 重新获取数据
    },

    // 统计信息切换（支持多选）
    async active2Change(index) {
      if (this.isIndex == 0) {
        const indexInArray = this.isIndex2.indexOf(index);
        console.log(indexInArray);

        if (indexInArray > -1) {
          // 如果已选中，则取消选中
          this.isIndex2.splice(indexInArray, 1);
          // 如果取消选择后没有选中任何板块，清空趋势图数据
          if (this.isIndex2.length === 0) {
            this.trendData = {};
            this.recruitmentData = {
              ...this.recruitmentData,
              dates: []
            };
            this.drawChart();
            return;
          }
        } else {
          // 如果未选中，则添加选中
          this.isIndex2.push(index);
        }

        await this.updateTrendChart();
      }
    },

    // 职位选择变化

    handlePositionChange(value) {
      this.positionId = value;

      this.getRecruitmentData(); // 重新获取数据
    },

    // 趋势图渲染

    drawChart() {
      let that = this;

      // 获取图表容器
      const chartDom = document.getElementById("main");
      if (!chartDom) return;

      // 如果已存在图表实例，先销毁
      if (this.myChart) {
        this.myChart.dispose();
      }

      // 初始化图表
      this.myChart = echarts.init(chartDom);

      // 使用API返回的趋势数据
      const trendDataObj = this.trendData || {};
      const xAxisData = this.recruitmentData && this.recruitmentData.dates
        ? this.recruitmentData.dates
        : [];

      // 构建系列数据
      const series = [];
      const colors = ['#409eff ', '#FE574A', '#67C23A', '#E6A23C', '#909399', '#509EFF'];

      this.isIndex2.forEach((typeIndex, i) => {
        const typeData = trendDataObj[typeIndex] || [];
        const data = typeData.map(item => item.count || 0);
        series.push({
          name: this.arrList[typeIndex].name,
          data: data,
          type: "line",
          // itemStyle: {
          //   color: colors[i % colors.length]
          // }
        });
      });

      // 如果没有选中任何类型，显示默认数据
      if (series.length === 0) {
        series.push({
          name: '默认',
          data: [],
          type: "line",
        });
      }

      //图表的配置项和数据
      var option = {
        title: {
          show: true,
        },

        tooltip: {
          // 触发方式：设置为坐标轴触发提示框

          trigger: "axis",

          // 设置提示框浮层位置 point: 鼠标位置

          position: function (point) {
            return [point[0] - 18, point[1] - 120];
          },

          padding: 0,

          // 提示框浮层内容格式器: 自定义提示框样式

          formatter: function (params) {
            // params 是 formatter 需要的数据集

            let content = "";

            // 提示框外框样式及内容数据
            let tooltipContent = `<div style="width: 120px; min-height: 70px;box-shadow: 0px 0px 3px 1px rgba(125,125,125,0.5);border-radius: 10px;padding:5px 0;box-sizing: border-box">

        <div style="color: #000000D9;text-align:center;margin:5px 0 7px 0 ">

        ${xAxisData[params[0].dataIndex]}

        </div>`;

            params.forEach((item) => {
              tooltipContent += `<div class="flex-box2" style="justify-content:center; margin: 5px 0;">
         <div style="margin-right:5px; width: 10px;height: 10px;background: #FFFFFF;border: 2px solid ${item.color};box-shadow: 0px 0px 2px 0px rgba(97,144,232,0.5);border-radius: 50%;">
        </div>
        <div>${item.seriesName} <span style="color:${item.color}">${item.data}</span> </div>
        </div>`;
            });

            tooltipContent += `</div>`;
            return tooltipContent;
          },
        },

        xAxis: {
          type: "category",

          data: xAxisData,
        },

        yAxis: {
          type: "value",
        },

        series: series,
      };

      //使用刚指定的配置项和数据显示图表。

      this.myChart.setOption(option);
    },

    // 近 1 4 12周切换时触发

    async recentlyChange(index) {
      this.recentlyIndex = index;
      if (this.isIndex2.length > 0) {
        await this.updateTrendChart();
      } else {
        this.$message.warning('请先选择统计类型')
      }
    },

    //  页码切换时触发

    async handleCurrentChange(page) {
      this.pagingObj.currentPage = page;
      await this.updateTableData();
    },

    //斑马线

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "row-style";
      }

      return "";
    },
  },
};
</script>

<style lang='less' scoped>
/deep/ .el-table .row-style {
  background: #eee;
}

.firm-body {
  .box {
    width: 1200px;

    min-height: 700px;

    box-sizing: border-box;

    overflow-y: auto;

    margin-top: 20px;

    background: #ffffff;

    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);

    border-radius: 20px;

    padding: 30px;

    .box-nav {
      display: flex;

      align-items: center;

      .nav-text {
        width: 110px;

        height: 35px;

        line-height: 35px;

        background: #eee;

        border-radius: 5px;

        text-align: center;

        font-size: 12px;

        color: #333;

        margin-right: 10px;

        cursor: pointer;
      }

      .active {
        background: rgba(97, 144, 232, 0.2);

        color: #409eff ;
      }
    }

    .change-box {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      height: auto;
      line-height: normal;
      margin: 10px 0 30px 0;
      padding: 0;
      border: none;
      border-radius: 0;
      color: inherit;
      background: transparent;
      box-shadow: none;
      font-size: 12px;
      text-align: left;
      justify-content: space-between;
      box-sizing: border-box;

      .change-item {
        width: 265px;
        margin: 20px 20px 0 0;
        padding: 15px 20px;
        box-sizing: border-box;
        height: 130px;
        background: #ffffff;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
        border-radius: 10px;
        cursor: pointer;
        float: none;
      }

      .change-item:hover {
        box-shadow: 0px 0px 5px 0px #409eff ;
      }

      .active2 {
        outline: 2px solid #409eff ;
        background: rgba(97, 144, 232, 0.05);
        box-shadow: 0px 0px 8px 0px rgba(97, 144, 232, 0.6);
      }
    }

    .change-item:nth-child(4n) {
      margin-right: 0;
    }

    .recently-box {
      display: flex;

      font-size: 14px;

      background: #ffffff;

      cursor: pointer;

      .recently-item {
        background: #ffffff;

        padding: 5px 8px;

        border-top: 1px solid #409eff ;

        border-bottom: 1px solid #409eff ;
      }

      .recently-item:first-child {
        border: 1px solid #409eff ;

        padding: 5px 8px;

        border-radius: 10px 0px 0px 10px;
      }

      .recently-item:last-child {
        border: 1px solid #409eff ;

        padding: 5px 8px;

        border-radius: 0px 10px 10px 0px;
      }

      .active {
        background-color: #409eff ;

        color: #fff;
      }
    }
  }
}
</style>